import { render, staticRenderFns } from "./PacientesPorSeguro.vue?vue&type=template&id=38dc428c&scoped=true&"
import script from "./PacientesPorSeguro.vue?vue&type=script&lang=ts&"
export * from "./PacientesPorSeguro.vue?vue&type=script&lang=ts&"
import style0 from "./PacientesPorSeguro.vue?vue&type=style&index=0&id=38dc428c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dc428c",
  null
  
)

export default component.exports